var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.74%",
    y1: "12.217%",
    x2: "82.252%",
    y2: "90.272%",
    id: "k1ethm82oa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: ".8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#k1ethm82oa)",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4F7",
    d: "m14.231 15.35-.006-2.184 1.287 1.76 2.075-.679-1.278 1.769 1.291 1.762-2.078-.668-1.276 1.772-.01-2.184-2.078-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.578 21.669a5.647 5.647 0 1 1 0-11.294c.507 0 .994.071 1.463.196a6.364 6.364 0 0 0-3.347-.953 6.4 6.4 0 0 0 0 12.8c1.228 0 2.372-.35 3.347-.95-.469.129-.957.2-1.463.2z",
    fill: "#F0F4F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.509c9d9948da5d0c8817976b04a32be0.svg";
export { ForwardRef as ReactComponent };